import React, { Component } from 'react';
import { Map as GoogleMap, GoogleApiWrapper, Marker as GoogleMarker } from 'google-maps-react';

export class Map extends Component {

  render() {
    return (
      <div id="map">
        <div className="map-canvas" ref={this.canvas}>
          <GoogleMap
            google={this.props.google}
            zoom={15}
            initialCenter={{
              lat: 32.736864, lng: -97.11343
            }}
          >
            <GoogleMarker 
              title={'Fuerza de los Barrios'}
              name={'fuerza'}
              position={{lat: 32.736864, lng: -97.11343}}
            />
          </GoogleMap>
        </div>
      </div>
    )
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyA1SZSsCZbofLkRa-L0jhhHxMVPfeRXO6Q'
})(Map);
